import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../models';

export type SPCredentialAgreementLoc = 'SPCredentialAgreement';

export const spCredentialAgreementLoc: LocDefs<SPCredentialAgreementLoc> = {
	SPCredentialAgreement: {
		defaultValue: '',
		description: 'Text of the agreement for the candidate to read and sign.',
		displayPath: 'Credentials|Agreement|Agreement Content',
		displayType: 'Content',
		legacyName: 'Credential.Agreement/Credentials.Agreement.Content.Agreement',
		htmlAllowed: true,
		shared: true,
		feature: HubFeature.CredentialAgreement,
		portal: 'SP',
	},
};

export const AGREEMENT_LOC = MapLocKeys<SPCredentialAgreementLoc>(spCredentialAgreementLoc);

export type SPCredentialAgreementLocType = LocMap<SPCredentialAgreementLoc>;
